module.exports = __webpack_public_path__ + "img/watermark-circle.17b96694.svg";